import api from "./api"; 

export async function getOrders(params) {
  const res = await api.get("admin/orders", { params });
  return res.data.data; 
}

export async function getOrder(id) {
  const res = await api.get(`admin/orders/${id}`);
  return res.data.data;
}

export async function acceptOrder(orderId, driverId) {
  const res = await api.post(`admin/orders/${orderId}/accept`, {
    id_driver: driverId,
  });

  return res.data.data;
}

export async function cancelOrder(id) {
  const res = await api.post(`admin/orders/${id}/cancel`);
  return res.data.data;
}
export async function completeOrder(id) {
  const res = await api.post(`admin/orders/${id}/finish`);
  return res.data.data;
}

export async function addOrderSupplement(orderId, payload) {
  const res = await api.post(`admin/orders/${orderId}/add-supplement`, payload);
  return res.data.data;
}

export async function removeOrderSupplement(supplementId) {
  const res = await api.delete(`admin/orders/remove-supplement/${supplementId}`);
  return res.data.data;
}